import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.25 14.5a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0Zm7.25-8.75a8.75 8.75 0 1 0 5.634 15.445l2.836 2.835a.75.75 0 1 0 1.06-1.06l-2.835-2.836A8.75 8.75 0 0 0 14.5 5.75Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }